import * as THREE from 'three';
import Picker from '../core/picker';
import { triangle } from '../math/triangle';
import triangulation from './triangulation';

const polylabel = require('polylabel');

export class labelPosition {
  // private ccw(double x1, double y1, double x2, double y2, double x3, double y3) {
  //     return cross(x2 - x1, y2 - y1, x3 - x2, y3 - y2);
  // }

  // private ccw(Point2D p1, Point2D p2, Point2D p3) {
  //     return ccw(p1.getX(), p1.getY(), p2.getX(), p2.getY(), p3.getX(), p3.getY());
  // }
  private ccw(p1: THREE.Vector2, p2: THREE.Vector2, p3: THREE.Vector2): number {
    const v1 = p2.clone().sub(p1);
    const v2 = p3.clone().sub(p2);
    return v1.cross(v2);
  }

  // Areaの凸多角形判定
  public ConvexPolygon(area: Array<THREE.Vector2>): boolean {
    const ccwArray = [];
    for (let i = 0; i <= area.length - 1; i++) {
      const v1 = area[i];
      const v2 = area[(i + 1) % area.length];
      const v3 = area[(i + 2) % area.length];
      ccwArray.push(this.ccw(v1, v2, v3));
    }
    const result = ccwArray.reduce((acc: Array<boolean>, value) => {
      if (value !== 0) {
        acc.push(value > 0);
      }
      return acc;
    }, []);

    const total = result.reduce((acc, value) => acc + (value ? 1 : 0), 0);
    // console.log(`${total === 0 || result.length === total}  ${result}`);
    return total === 0 || result.length === total;
  }

  public labelPosition(area: Array<THREE.Vector2>) {
    if (this.ConvexPolygon(area)) {
      return this.centerOfGravity(area);
    }
    const pos = this.polylabel_(area);
    return new THREE.Vector2(pos[0], pos[1]);
  }

  public polylabel_(area: Array<THREE.Vector2>): any {
    const polygon: number[][] = [];
    for (let i = 0; i < area.length; i++) {
      polygon.push([area[i].x, area[i].y]);
    }
    return polylabel([polygon]);
    // return polylabel([[[-61.12164679999998,14.719282999874112],[-61.118520099999984,14.716243299873753],[-61.118533599999985,14.714449199873544],[-61.11560209999999,14.707324599872702],[-61.114850899999986,14.7064851998726],[-61.11324869999999,14.702683499872153],[-61.11345009999997,14.698760199871698],[-61.11533549999999,14.696649699871445],[-61.11624509999997,14.692965299871007],[-61.11621679999998,14.690845599870748],[-61.11986609999999,14.68999179987065],[-61.12306309999998,14.690357399870694],[-61.12441609999996,14.690013999870656],[-61.12809369999997,14.689801299870622],[-61.13247369999996,14.690191999870686],[-61.13464879999999,14.689540999870605],[-61.138730599999974,14.689939299870646],[-61.141242599999984,14.688848099870523],[-61.142479399999985,14.690421899870707],[-61.145638399999996,14.689443199870583],[-61.14803509999997,14.690422299870711],[-61.14888629999999,14.691853299870873],[-61.15150159999998,14.691337299870817],[-61.15423579999998,14.693721399871094],[-61.15542679999999,14.695230199871265],[-61.155833699999995,14.697952299871593],[-61.15880649999998,14.701841399872057],[-61.15830539999999,14.704165699872322],[-61.15885469999997,14.707112499872668],[-61.15811579999998,14.707497499872714],[-61.15770799999998,14.713293699873402],[-61.150605299999995,14.713043599873382],[-61.14696559999998,14.715907599873715],[-61.14383019999999,14.71597429987372],[-61.142535699999996,14.717774899873941],[-61.14093769999999,14.718257099873984],[-61.13791339999998,14.717131299873854],[-61.135850699999985,14.717888699873951],[-61.13320559999999,14.719708999874156],[-61.128336099999984,14.720843599874287],[-61.12375529999998,14.719032499874077],[-61.12209809999999,14.718675499874038],[-61.12164679999998,14.719282999874112]]]);
  }

  // 多角形の重心
  public centerOfGravity(area: Array<THREE.Vector2>): THREE.Vector2 {
    const triangle = new triangulation();
    const triangles: triangle[] = triangle.position(area);

    let s = 0.0;
    let lx = 0;
    let ly = 0;

    triangles.forEach((triangle) => {
      const pos = triangle.centerOfGravity();
      const size = triangle.size();
      lx += (size * pos.x);
      ly += (size * pos.y);
      s += size;
    });
    return new THREE.Vector2(lx / s, ly / s);
  }

  // min/max領域の中心
  public centerOfBounds(area: Array<THREE.Vector2>) : THREE.Vector2 {
    this.clearRange();
    this.range(area);
    return new THREE.Vector2(this.minX + (this.maxX - this.minX) / 2, this.minY + (this.maxY - this.minY) / 2);
  }

    private minX: number = Number.MAX_VALUE;

    private maxX: number = -Number.MAX_VALUE;

    private minY: number = Number.MAX_VALUE;

    private maxY: number = -Number.MAX_VALUE;

    private clearRange() {
      this.minX = Number.MAX_VALUE;
      this.maxX = -Number.MAX_VALUE;
      this.minY = Number.MAX_VALUE;
      this.maxY = -Number.MAX_VALUE;
    }

    private range(area: Array<THREE.Vector2>) {
      for (let i = 0; i < area.length; i++) {
        this.minX = Math.min(this.minX, area[i].x);
        this.maxX = Math.max(this.maxX, area[i].x);
        this.minY = Math.min(this.minY, area[i].y);
        this.maxY = Math.max(this.maxY, area[i].y);
      }
    }

    position(area: Array<THREE.Vector2>): THREE.Vector2[] {
      const pick = new Picker();

      // let minX = Number.MAX_VALUE;
      // let maxX = -Number.MAX_VALUE;
      // let minY = Number.MAX_VALUE;
      // let maxY = -Number.MAX_VALUE;
      const points: Array<THREE.Vector2> = [];
      this.range(area);

      const distX = this.maxX - this.minX;
      const distY = this.maxY - this.minY;
      const DIV = 20;

      for (let i = 0; i <= DIV; i++) {
        const qx = distX / DIV * i;
        for (let j = 0; j <= DIV; j++) {
          const qy = distY / DIV * j;

          const point = new THREE.Vector2(this.minX + qx, this.minY + qy);
          if (!pick._Check(area, point)) continue;
          points.push(point);
        }
      }

      const maxIndex = (nums: Array<number>) => {
        let index = 0;
        let value = -Number.MAX_VALUE;
        for (let i = 0, l = nums.length; i < l; i++) {
          if (value < nums[i]) {
            value = nums[i];
            index = i;
          }
        }
        return index;
      };

      const distanceList = [];

      for (let i = 0; i < area.length; i++) {
        const dist: Array<number> = [];

        for (let j = 0; j < points.length; j++) {
          const p = points[j];
          const p3 = this.closestPoint(p, area[i], area[(i + 1) % area.length]);
          const d = p.distanceTo(p3);
          // value = Math.max(value, d);
          dist.push(d);
        }
        const index = maxIndex(dist);
        distanceList.push(index);
        console.log(`${index} - ${dist}`);
      }

      const pnt = distanceList.map((index) => points[index]);
      return pnt;

      // return points[maxIndex(distanceList)];
    }

    // 線分内に近傍点がある場合はその座標を返し、線分外はstart,endの値を返す
    private closestPoint(point: THREE.Vector2, start: THREE.Vector2, end:THREE.Vector2) : THREE.Vector2 {
      const myVector: THREE.Vector2 = new THREE.Vector2(point.x - start.x, point.y - start.y);
      const baseVector: THREE.Vector2 = new THREE.Vector2(end.x - start.x, end.y - start.y);
      const dot: number = myVector.dot(baseVector);
      if (dot <= 0) return start;

      const nBaseLength: number = baseVector.length();
      const nProjection: number = dot / nBaseLength;
      if (nProjection < nBaseLength) {
        baseVector.multiplyScalar(nProjection / nBaseLength);
        return new THREE.Vector2(start.x + baseVector.x, start.y + baseVector.y);
      }
      return end;
    }
}
